@if (enabled) {
    <!-- Floating Action Button -->
    <button class="support-fab" (click)="toggle()" [class.active]="view !== 'closed'" aria-label="Support">
        @if (view === 'closed') {
            <span class="support-fab-icon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
            </span>
        }
        @if (view !== 'closed') {
            <span class="support-fab-icon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </span>
        }
    </button>
    <!-- Panel -->
    <div class="support-panel" [class.open]="view !== 'closed'">
        <!-- Header -->
        <div class="support-panel-header">
            @if (view === 'new' || view === 'detail') {
                <button class="support-back-btn" (click)="showList()">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="15 18 9 12 15 6" />
                    </svg>
                </button>
            }
            <div class="support-panel-title">
                @if (view === 'list') {
                    <span>Support</span>
                }
                @if (view === 'new') {
                    <span>New Request</span>
                }
                @if (view === 'detail') {
                    <span>{{ selectedTicketKey }}</span>
                }
            </div>
            <button class="support-close-btn" (click)="close()">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>
        <!-- Body -->
        <div class="support-panel-body">
            <!-- Admin: not connected (only shown to team@hutsix.com.au) -->
            @if (isAdmin && connected === false && view === 'list') {
                <div class="support-connect">
                    <div class="support-connect-icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                        </svg>
                    </div>
                    <p class="support-connect-title">Connect to Jira Service Desk</p>
                    @if (authMethod === 'api-token') {
                        <p class="support-connect-sub">Jira API credentials are not configured. Set the following environment variables:</p>
                        <code class="support-connect-url">JIRA_API_EMAIL<br />JIRA_API_TOKEN<br />JIRA_BASE_URL</code>
                    }
                    @if (authMethod !== 'api-token') {
                        <p class="support-connect-sub">
                            Install the Connect app in Jira admin:<br />
                            Manage apps > Upload app > paste this URL:
                        </p>
                        <code class="support-connect-url">{{ connectDescriptorUrl }}</code>
                    }
                </div>
            }
            <!-- Normal ticket views (shown when connected or for non-admin users) -->
            @if (!isAdmin || connected !== false) {
                @if (view === 'list') {
                    <app-support-ticket-list (selectTicket)="showDetail($event)" (newTicket)="showNewTicket()"> </app-support-ticket-list>
                }
                @if (view === 'new') {
                    <app-support-ticket-form (ticketCreated)="onTicketCreated()" (cancel)="showList()"> </app-support-ticket-form>
                }
                @if (view === 'detail') {
                    <app-support-ticket-detail [issueKey]="selectedTicketKey"> </app-support-ticket-detail>
                }
            }
        </div>
    </div>
}
